// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0cacac2c","396":"630ce092","453":"f3ae13be","455":"7b80dfa5","977":"0ab1240b"}[chunkId] + ".chunk.js";
};